<template>
  <div class="edition-table">
    <table>
      <thead>
        <th>
          Quarto
          <InfoTooltip
            :tooltipMinWidth="225"
            text="Quartos que estão ativos neste hotel."
            class="tooltip-space"
          />
        </th>

        <th>
          Acréscimo ou Desconto
          <InfoTooltip
            :tooltipMinWidth="220"
            text="Se os valores configurados para esta acomodação serão acrescidos ou descontados do valor da tarifa base."
            class="tooltip-space"
          />
        </th>

        <th>
          Tipo de valor
          <InfoTooltip
            :tooltipMinWidth="210"
            text="Se os valores para acréscimo ou desconto, em relação à tarifa base, representam um valor monetário absoluto ou um em percentual."
            class="tooltip-space"
          />
        </th>

        <th>
          Valor
          <InfoTooltip
            :tooltipMinWidth="210"
            text="Valor a ser considerado para diferencial, segundo as configurações de acréscimo ou desconto e também o tipo de valor."
            class="tooltip-space"
          />
        </th>
      </thead>

      <tbody>
        <!-- LINHA -->
        <tr v-for="(room, i) in rooms" :key="`room-${room.codigoQuarto || i}`">
          <!-- NOME DO QUARTO -->
          <td class="td--padd__text">
            {{ room.nomeQuarto }}
          </td>

          <!-- ACRÉSCIMO OU DESCONTO -->
          <td class="td--padd">
            <FormSelect
              v-model="room.tableTipoDiferencial"
              :options="roomsDiscountOptions"
              label=""
              class="td--padd__input"
            />
          </td>

          <!-- TIPO DE VALOR -->
          <td class="td--padd">
            <FormSelect
              v-model="room.tableTipoValor"
              :options="roomsTypeOptions"
              label=""
              class="td--padd__input"
            />
          </td>

          <!-- VALOR -->
          <td class="td--padd">
            <FormInput
              v-if="room.tableTipoValor.value === 1"
              v-model="room.valor"
              label=""
              placeholder="00,00"
              sufix="%"
              class="td--padd__input"
            />
            <PmwFormCurrencyInput
              v-else-if="room.tableTipoValor.value === 2"
              v-model="room.valor"
              :options="{ precision: 2 }"
              size="large"
              label=""
              placeholder="00,00"
              suffix="R$"
              class="td--padd__input"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/** ======================================================= */
/** Componente da tabela de Tipo de Acomodação */
/** ======================================================= */
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import PmwFormCurrencyInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormCurrencyInput'
import FormSelect from '@solucoes/components-lib-tmp/src/components/elements/FormSelect'
import InfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/InfoTooltip'

export default {
  name: 'AccommodationTable',
  components: {
    FormInput,
    PmwFormCurrencyInput,
    FormSelect,
    InfoTooltip
  },
  props: {
    /** Controla o envio dos dados para a página */
    sendData: {
      type: Boolean,
      default: false
    },
    /** Configuração dos quartos */
    rooms: {
      type: Array,
      default: () => []
    },
    /** Opções de Acrescimo ou Desconto */
    roomsDiscountOptions: {
      type: Array,
      default: () => []
    },
    /** Opções de tipo de valor */
    roomsTypeOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      room: {
        tableTipoDiferencial: {
          text: 'Acréscimo',
          value: 1
        },
        tableTipoValor: {
          text: 'Absoluto',
          value: 2
        },
        valor: null
      }
    }
  },
  watch: {
    sendData() {
      this.$emit('input', this.rooms)
    }
  }
}
</script>

<style lang="scss" scoped>
.tooltip-space {
  margin-left: 7px;
  text-align-last: left;
}

.edition-table {
  max-width: 1236px;

  table {
    th {
      padding: 15px 55px;
    }

    th,
    td {
      vertical-align: middle;
      border: 1px solid $gray-border;
      font-size: font-size('size-small');
      white-space: nowrap;

      & + & {
        border-left: none;
      }

      &.empty {
        background-color: $gray-lightest;
      }
    }

    th {
      font-weight: font-weight('weight-medium');
      text-align-last: center;
    }

    .td {
      padding: 0;
      min-width: 1px;

      &--padd {
        padding: 15px 35px;
        ::v-deep .input-checkbox {
          margin: 0px auto;
          display: table;
        }
        &__text {
          font-weight: font-weight('weight-medium');
          color: pmw-colors('grey-80');
          text-align: -webkit-center;
        }
        &__input {
          width: 130px;
          margin-bottom: 15px;
        }
      }
    }
  }
}
table th:nth-child(2) {
  width: 200px;
  padding: 5px 25px;
}
::v-deep .input--field {
  padding: 0px 0px 0px 0px;
}
</style>
